module.exports = __webpack_public_path__ + "static/img/zonghexinxi.30d95ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/zonghexinxi.png
// module id = T78R
// module chunks = 44